module.exports = __webpack_public_path__ + "c72de5c941ed76a9acc387683e5567d4.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/new-design/icons/visa.svg
// module id = 1277
// module chunks = 73